import BannerCase from './banner-case';
import ContentCase from './content-case';

type ListPathType = {
    name: string;
    path: string;
};
type TitleCasePropsType = {
    img: string;
    video?: string;
    className?: string;
    caseName: string;
    listTitle: any;
    listPath: ListPathType[];
};

const TitleCase = ({
    img,
    video,
    className = '',
    caseName,
    listTitle,
    listPath,
}: TitleCasePropsType) => {
    return (
        <>
            <BannerCase img={img} video={video} className={className} listPath={listPath} />
            <ContentCase caseName={caseName} listTitle={listTitle} />
        </>
    );
};

export default TitleCase;
